var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{on:{"click":_vm.deleteClicked}},[_vm._v(" Usuń ogłoszenie ")])}
var staticRenderFns = []

export { render, staticRenderFns }